"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const recoil_1 = require("recoil");
const functions_1 = require("@/common/functions");
exports.default = (0, recoil_1.atom)({
    key: 'searchParamState',
    default: { searchKeyword: (0, functions_1.getSearchParam)('keyword'), searchFond: (0, functions_1.getSearchParam)('fond') },
});
